import { render, staticRenderFns } from "./UploadsProgress.vue?vue&type=template&id=51c76176&scoped=true&"
import script from "./UploadsProgress.vue?vue&type=script&lang=js&"
export * from "./UploadsProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c76176",
  null
  
)

export default component.exports